import React from "react"
import Layout from "../components/layout"
import Banner from "../components/banner"
import Services from "../components/services"
import Contact from "../components/contact"
import HeadersData from "../data/headers.json"
import Clients from "../components/clients"

const Index = () => {
  return (
    <Layout>
      <Banner headers={HeadersData} />
      <Services />
      <Clients />
      <Contact />
    </Layout>
  )
}

export default Index
